export const DOMAIN_PREFIX = 'Zedoc/';
export const DOMAIN_CLIENT = `${DOMAIN_PREFIX}Client/`;
export const DOMAIN_PROJECTS = `${DOMAIN_PREFIX}Client/Projects/`;
